import styled from '@emotion/styled';
import { FunctionComponent } from 'react';
import Async from 'react-select/async';

import { reactSelectStyleOverrides } from './ExinSelect';

/**
 * A react-select <Async> with custom styles
 */
const ExinAsyncSelectInner = styled(Async)`
  font-family: Roboto, sans-serif;
  font-size: 0.875em;
  @media (min-width: 600px) {
    font-size: 1em;
  }
`;

const ExinAsyncSelect: FunctionComponent<
  typeof Async extends FunctionComponent<infer P> ? P : unknown
> = (props) => <ExinAsyncSelectInner {...props} styles={reactSelectStyleOverrides} />;

export default ExinAsyncSelect;
